import React from "react";

/**
 * Reusable Decorative Grid Lines Component - Variant 4 (Game Page)
 *
 * Design Spec:
 * - Row 1 (Top): Spans full screen width (2/3 box height)
 * - Rows 2..6: Positioned on Left and Right sides only:
 *   - Rows 2..5 (4 Middle rows): Normal 1fr height boxes with 3x3 mini grid
 *   - Row 6 (Bottom): 1/3 height box
 *
 * @param {string} variant - Optional layout variant name
 * @param {string} label - Optional target node label
 */
const DecorativeLines4 = ({ variant = "default", label = "" }) => {
    const sideRows = [2, 3, 4, 5, 6];
    const miniSubgrid = [1, 2, 3, 4, 5, 6, 7, 8, 9];

    const renderSideGroup = (side) => (
        <div
            className={`DecorativeLines4__side DecorativeLines4__side--${side}`}
        >
            {sideRows.map((rowIndex) => {
                const isMiddle = rowIndex >= 2 && rowIndex <= 5;
                const isBottom = rowIndex === 6;

                return (
                    <div
                        key={`${side}-row-${rowIndex}`}
                        className={`DecorativeLines4__box DecorativeLines4__box--${rowIndex} ${
                            isMiddle ? "DecorativeLines4__box--subgrid" : ""
                        } ${isBottom ? "DecorativeLines4__box--bottom" : ""}`}
                    >
                        {isMiddle && (
                            <div className="DecorativeLines4__mini-grid">
                                {miniSubgrid.map((subIndex) => (
                                    <div
                                        key={`sub-${subIndex}`}
                                        className="DecorativeLines4__mini-cell"
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );

    return (
        <div className={`DecorativeLines4 DecorativeLines4--${variant}`}>
            {/* Top row stretching 100% full screen width */}
            <div className="DecorativeLines4__top-row" />

            {/* Main body with left & right sides (rows 2..6) */}
            <div className="DecorativeLines4__body">
                {renderSideGroup("left")}
                {renderSideGroup("right")}
            </div>
        </div>
    );
};

export default DecorativeLines4;
